import { render, staticRenderFns } from "./HSDeal.vue?vue&type=template&id=d2be9b8c&scoped=true"
import script from "./HSDeal.vue?vue&type=script&lang=js"
export * from "./HSDeal.vue?vue&type=script&lang=js"
import style0 from "./HSDeal.vue?vue&type=style&index=0&id=d2be9b8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2be9b8c",
  null
  
)

export default component.exports